function getParamStr(nameArr, pageDetail) {
  if (pageDetail) {
    nameArr = nameArr.concat(
      Object.keys(pageDetail).map(v => {
        if (v === 'keyWordList') {
          return pageDetail[v].join('&&');
        } else {
          return pageDetail[v];
        }
      })
    );
  }
  return nameArr.join('|');
}

var mutations = {
  setQueryObj(state, query) {
    let { queryObj } = state;
    // 这里query参数制作追加不做覆盖，因为不确定哪些是需要追踪需要的参数
    state.queryObj = { ...queryObj, ...query };
  },
  setWindowStyle(state, payload) {
    let obj = state.window;
    state.window = Object.assign({}, obj, payload);
  },
  setAwardRole(state, payload) {
    let { roleName } = payload;
    state.awardRole = payload;
  },
  setSubTabs(state, payload) {
    let { list } = payload;
    state.subTabs = list;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js